import { createContext, useContext, useState, useMemo, useCallback } from 'react';
import OverlayLoader from '../OverlayLoader/OverlayLoader';
import { LoaderContextValue, LoaderProviderProps } from './types/propsType';

const LoaderContext = createContext<LoaderContextValue>({
  showLoader: () => {
    /* do nothing */
  },
  hideLoader: () => {
    /* do nothing */
  },
});

const LoaderProvider = ({ children }: LoaderProviderProps) => {
  const [showLoading, setShowLoading] = useState(false);
  const showLoader = useCallback(() => {
    setShowLoading(true);
  }, []);
  const hideLoader = useCallback(() => {
    setShowLoading(false);
  }, []);
  const value = useMemo(
    () => ({
      showLoader,
      hideLoader,
    }),
    [showLoader, hideLoader],
  );
  return (
    <LoaderContext.Provider value={value}>
      {children}
      {showLoading ? <OverlayLoader /> : null}
    </LoaderContext.Provider>
  );
};

export function useLoader() {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  return { showLoader, hideLoader };
}

export default LoaderProvider;
